import { Button, DataGrid, TextBox } from 'devextreme-react';
import { Column, FilterRow, Pager, Paging, Scrolling, Summary, TotalItem } from 'devextreme-react/data-grid';
import React, { useRef } from 'react';
import { FormatNumber, ConvertDateFormat, ConvertDateTimeFormat } from '../../common';
import './card-bill-list.scss';
import "react-datepicker/dist/react-datepicker.css";
import DateBox from 'devextreme-react/date-box';
import { ExcelExport } from '../../common/excel';
import CardBillWithdrawRequestPopupContainer from './card-bill-withdraw-request-popup-container';
import CardBillAccountInfoPopupContainer from './card-bill-account-info-popup-container';

import { locale } from 'devextreme/localization';
locale('ko'); // DateBox 한글 사용

const CardBillList = ({ cardBillList, onValueChanged, useInfo, onClickSearch, cusEntAmount, onClickWithdraw, onClickAccountInfo }) => {

  const refDataGid = useRef(null);

  return (
    <React.Fragment>
      <div className="mileage-list">
        
        <div className="title">
        <div className="title-name">마일리지내역</div>
        <div className="mileage-list-top-label-amount">잔액</div>
          <div className="mileage-list-top-label-value">
            <TextBox
              width="80"
              // enabled={false}
              readOnly={true}
              stylingMode='outlined'
              style={{ backgroundColor: 'white', height: '30px' }}
              value={FormatNumber(cusEntAmount.Amount) + '원'}
            />
          </div>
          <div className="mileage-list-top-label-amount-withdraw">
            <Button
                className="Btn"
                stylingMode="contained"
                type="default"
                text="출금"
                onClick={onClickWithdraw}
            />
          </div>
          <div className="mileage-list-top-label-amount-withdraw">
            <Button
                className="Btn"
                stylingMode="contained"
                type="default"
                text="계좌편집"
                onClick={onClickAccountInfo}
            />
          </div>
        </div>
        
        
        <div className="mileage-list-top">
          <div className="mileage-list-top-label">기간 : </div>
          <div className="mileage-list-top-value">
            <DateBox
              type="date"
              defaultValue={new Date()}
              width={90}
              value={useInfo.FromDate}
              displayFormat="yyyy-MM-dd"
              stylingMode='outlined'
              onValueChanged={(e) => onValueChanged('FromDate', e)}
              openOnFieldClick={true}
              acceptCustomValue={false}
              style={{ backgroundColor: 'white', height: '30px' }}
            />
          </div>
          <div className="mileage-list-top-label-wave"> ~ </div>
          <div className="mileage-list-top-value">
            <DateBox
              type="date"
              defaultValue={new Date()}
              width={90}
              value={useInfo.ToDate}
              displayFormat="yyyy-MM-dd"
              stylingMode='outlined'
              onValueChanged={(e) => onValueChanged('ToDate', e)}
              openOnFieldClick={true}
              acceptCustomValue={false}
              style={{ backgroundColor: 'white', height: '30px' }}
            />
          </div>
          <div className="mileage-list-top-label-amount-search">
            <Button
                className="Btn"
                stylingMode="contained"
                type="default"
                text="조회"
                onClick={onClickSearch}
            />
          </div>
          <div className="mileage-list-top-label-amount-excel">
            <Button
                className="Btn"
                stylingMode="contained"
                type="success"
                text="엑셀"
                onClick={() =>
                  ExcelExport(
                    refDataGid.current.instance,
                    (useInfo.FromDate === useInfo.ToDate ? useInfo.ToDate : useInfo.FromDate + '~' + useInfo.ToDate) + ' 마일리지 적립현황.xlsx'
                  )
                }
            />
          </div>
        </div>
        <div className="grid">
          <DataGrid
            className="grid100"
            columnAutoWidth={false}
            allowColumnResizing={true}
            dataSource={cardBillList}
            keyExpr="AppDate"
            noDataText="마일리지 적립현황이 없습니다."
            showBorders={true}
            rowAlternationEnabled= {true} // 짝수 row 색상
            showColumnLines={true} // column 구분선
            ref={refDataGid}
            wordWrapEnabled={true}
          >
            <Scrolling rowRenderingMode="virtual" />
            <Column
              dataField="AppDateTime" 
              caption="일시" 
              alignment="center"
              width="70"
              customizeText={(e) => ConvertDateTimeFormat(e.value)}
            />
            {/* <Column
              dataField="AppDate"
              caption="접수일자"
              alignment="center"
              width={150}
              customizeText={(e) => ConvertDateFormat(e.value)}
            />
            <Column
              dataField="AgencyName"
              caption="접수업체"
              alignment="center"
              width={150}
            /> */}
            <Column
              dataField="StateName"
              caption="상태"
              alignment="center"
              width="50"
            />
            <Column
              dataField="InOutAmount"
              caption="입출금"
              alignment="center"
              width="60"
              customizeText={(e) => FormatNumber(e.value)}
            />
            {/* <Column
              dataField="OutAmount"
              caption="출금"
              alignment="center"
              width={150}
              customizeText={(e) => FormatNumber(e.value) + '원'}
            /> */}
            
            <Column
              dataField="TotalMileageAmount"
              caption="총액"
              alignment="center"
              width="60"
              customizeText={(e) => FormatNumber(e.value)}
            />
            <Column
              dataField="Remark"
              caption="비고"
              alignment="left"
              width="300"
            />
            <Paging defaultPageSize={15} enabled={true} />
            <Pager showPageSizeSelector={false} showInfo={false} />
            <Summary>
                  <TotalItem
                      column="AppDateTime"
                      summaryType="count"
                      displayFormat={(value) => '총 건수 : ' + new Intl.NumberFormat('ko').format(value)}
                  />
                  <TotalItem
                      column="InAmount"
                      summaryType="sum"
                      displayFormat={(value) => new Intl.NumberFormat('ko').format(value) + '원'}
                  />
                  <TotalItem
                      column="OutAmount"
                      summaryType="sum"
                      displayFormat={(value) => new Intl.NumberFormat('ko').format(value) + '원'}
                  />
              </Summary>
          </DataGrid>
        </div>
      </div>
      <CardBillWithdrawRequestPopupContainer />
      <CardBillAccountInfoPopupContainer />
    </React.Fragment>
  );
};

export default React.memo(CardBillList);
